import { useParams } from 'react-router-dom';

export function useConferenceId() {
    const { conferenceId } = useParams<{ conferenceId: string }>();

    return conferenceId;
}
